'use client'

import React from 'react';
import styled from 'styled-components';

const SocialAccountCard = ({ name, title, icon, url }) => {
  return (
    <StyledWrapper>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="card-link"
      >
        <div className="cardCollection">
          <div className="cardCollectionimg">{icon}</div>
          <div className="cardCollectiontextBox">
            <div className="cardCollectiontextContent">
              <p className="cardCollectionh1">{name}</p>
              <span className="cardCollectionspan">
                <label className="cardCollectioncheckbox-container">
                  <input
                    type="checkbox"
                    defaultChecked
                    className="cardCollectioncustom-checkbox"
                  />
                  <span className="cardCollectioncheckmark" />
                </label>
              </span>
            </div>
            <p className="cardCollectionp">{title}</p>
          </div>
        </div>
      </a>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .card-link {
    text-decoration: none;
  }

  .cardCollection {
    width: 100%;
    max-width: 290px;
    height: 90px;
    background: #353535;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: left;
    transition: 0.5s ease-in-out;
  }

  .cardCollection:hover {
    cursor: pointer;
    transform: scale(1.05);
  }

  .cardCollectionimg {
    width: 60px;
    height: 60px;
    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    border-radius: 10px;
    background: white;
  }

  .cardCollectiontextBox {
    width: calc(100% - 90px);
    margin-left: 10px;
    color: white;
    font-family: "Poppins", sans-serif;
  }

  .cardCollectiontextContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .cardCollectionh1 {
    font-size: 16px;
    font-weight: bold;
  }

  .cardCollectionp {
    font-size: 12px;
    font-weight: lighter;
  }

  .cardCollectioncheckbox-container {
    display: inline-block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 16px;
    user-select: none;
  }

  .cardCollectioncustom-checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .cardCollectioncheckmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 4px;
    transition: background-color 0.3s;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }

  .cardCollectioncheckmark:after {
    content: "";
    position: absolute;
    display: none;
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }

  .cardCollectioncustom-checkbox:checked ~ .cardCollectioncheckmark {
    background-color: #2196f3;
    box-shadow: 0 3px 7px rgba(33, 150, 243, 0.3);
  }

  .cardCollectioncustom-checkbox:checked ~ .cardCollectioncheckmark:after {
    display: block;
    animation: checkAnim 0.2s forwards;
  }

  @keyframes checkAnim {
    0% {
      height: 0;
    }
    100% {
      height: 10px;
    }
  }
`;

export default SocialAccountCard;
